export function lpad (str: any, length: number, character = '0') {
    str = String(str);
    while (str.length < length) {
        str = character + str;
    }
    return str;
}